export const areRecordsFewerThanPageSize = (records = [], pageSize) => {
  return Array.isArray(records) && records.length < pageSize;
};
